import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum OnlinePaymentStatus {
	INCOMPLETE = 1,
	FAILED = 2,
	SUCCESS = 3,
	REFUND = 4
}


export namespace OnlinePaymentStatus {

	export function getTitle(type: OnlinePaymentStatus): string {
		return Object.keys(OnlinePaymentStatus).find(key => OnlinePaymentStatus[key] === type);
	}

}

@Pipe({
	name: 'onlinePaymentStatusText',
	standalone: true
})
export class OnlinePaymentStatusTextPipe implements PipeTransform {

	onlinePaymentStatus = OnlinePaymentStatus;
	translatedText: string;

	constructor(
		private translateService: TranslateService
	) { }

	transform(value: OnlinePaymentStatus): any {
		this.getTranslate(
			this.onlinePaymentStatus.getTitle(value)
		);
		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.ONLINE_PAYMENT_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}










